import { DotLottiePlayer } from '@dotlottie/react-player';
import React, { useEffect, useState } from 'react';
import { getTenant } from '../../Utils/storageUtils';
import { TenantType } from '../../Utils/types';
import YesBankLoader from '../YesBank/Common/YesBankLoader';
import styles from './index.module.css';
import MahindraLoader from '../Mahindra/DashBoard/Common/Loader';
import { getLottiePath } from '../../Utils/assetUtils';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
interface Props {
  isPartialLoader?: boolean;
  isAdditionalAccountJourney?: boolean;
  loaderHeight?: number;
}

const NativeLoader: React.FC<Props> = ({
  isPartialLoader = false,
  isAdditionalAccountJourney = false,
  loaderHeight,
}) => {
  const [showToast, setShowToast] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    // Show initial toast after 5 seconds for JFS tenant
    let toastTimer: NodeJS.Timeout;

    if (getTenant() === TenantType.JFS) {
      // Show "Still fetching your data." after 5 seconds
      toastTimer = setTimeout(() => {
        setShowToast(true);
        // Add entrance animation delay
        setTimeout(() => {
          setIsToastVisible(true);
        }, 50);
      }, 5000);
    }

    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
      if (toastTimer) clearTimeout(toastTimer);
    };
  }, []);

  const Shimmer = ({ height = 200, borderRadius = 12 }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <div
        className={`${styles.shimmerDonutBar} ${styles.shimmerDonutBarBottom}`}
      ></div>
      <div
        className={`${styles.shimmerDonutBar} ${styles.shimmerDonutBarBottom}`}
      ></div>
    </div>
  );

  // Donut ring shimmer effect
  const DonutShimmer = () => (
    <div style={{ position: 'relative', width: 280, height: 280 }}>
      <svg
        className={styles.shimmerDonutRing}
        width='280'
        height='280'
        viewBox='0 0 280 280'
      >
        <defs>
          <linearGradient id='shimmerGradient'>
            <stop offset='0%' stopColor='#f0f0f0' />
            <stop offset='50%' stopColor='#e0e0e0' />
            <stop offset='100%' stopColor='#f0f0f0' />
          </linearGradient>
        </defs>
        <circle
          className={styles.shimmerDonutRingCircle}
          cx='140'
          cy='140'
          r='120'
        />
      </svg>
      <div className={styles.shimmerDonutCenter}>
        <div
          className={`${styles.shimmerDonutBar} ${styles.shimmerDonutBar1}`}
        ></div>
        <div
          className={`${styles.shimmerDonutBar} ${styles.shimmerDonutBar2}`}
        ></div>
        <div
          className={`${styles.shimmerDonutBar} ${styles.shimmerDonutBar3}`}
        ></div>
      </div>
      {/* Row of two shimmer rectangles below donut, at extreme ends */}
    </div>
  );
  return getTenant() === TenantType.PB ? (
    <div
      className={`${
        isPartialLoader ? styles.partialRootPB : styles.loaderRootPB
      }`}
    >
      <DotLottiePlayer
        id='loadingLottie'
        src={getLottiePath('generic.lottie')}
        autoplay
        loop
        style={{
          height: isPartialLoader
            ? isAdditionalAccountJourney
              ? '10%'
              : '15%'
            : '10%',
        }}
      />
      <span>Please Wait...</span>
    </div>
  ) : getTenant() === TenantType.YESBANK ? (
    <YesBankLoader />
  ) : getTenant() === TenantType.MAHINDRA ? (
    <MahindraLoader />
  ) : getTenant() === TenantType.JFS ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 'var(--max-width)',
        height: loaderHeight ? `calc(100vh - ${loaderHeight}px` : '100%',
        background: '#ffffff',
        padding: 24,
        boxSizing: 'border-box',
        position: 'absolute',
        zIndex: 12,
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: 'var(--max-width)',
        }}
      >
        {/* Shimmer for donut chart (ring) */}
        <DonutShimmer />
        {/* Shimmer for asset breakdown */}
        <Shimmer height={120} borderRadius={12} />
        <Shimmer height={240} borderRadius={12} />
        <Shimmer height={240} borderRadius={12} />
        <Shimmer height={240} borderRadius={12} />
        <Shimmer height={240} borderRadius={12} />
      </div>

      <div style={{ marginBottom: '15vh' }}>
        <DotLottiePlayer
          src={getLottiePath('jfsLoader.lottie')}
          autoplay
          loop
          style={{
            height: 32,
            width: 32,
          }}
        />
      </div>

      {/* Toast messages */}
      {showToast && (
        <div
          style={{
            position: 'fixed',
            bottom: '4.5rem',
            left: '5%',
            right: '5%',
            width: '90%',
            height: '3.5rem',
            background: '#2C2E31',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: isToastVisible
              ? '0px 16px 32px rgba(12, 13, 16, 0.16), 0px 16px 48px rgba(12, 13, 16, 0.16)'
              : '0px 4px 8px rgba(12, 13, 16, 0.08)',
            borderRadius: '0.875rem',
            padding: '1rem 1.5rem',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 10001,
            color: '#FFFFFF',
            fontSize: '14px',
            fontFamily:
              'JioType Var, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
            boxSizing: 'border-box',
            opacity: isToastVisible ? 1 : 0,
            transform: `
              translateY(${isToastVisible ? '0' : '20px'})
              scale(${isToastVisible ? '1' : '0.95'})
            `,
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            overflow: 'hidden',
          }}
        >
          <span style={{ textAlign: 'left', whiteSpace: 'nowrap' }}>
            Still fetching your data.
          </span>
        </div>
      )}
    </div>
  ) : getTenant() === TenantType.AU ? (
    <div className={styles.aubankNativeLoader}>
      <DotLottieReact
        src={getLottiePath('/aubank/nativeLoader.lottie')}
        autoplay
        loop
        style={{
          height: 56,
        }}
      />
      <div className={styles.aubankNativeLoaderText}>
        <span className={styles.aubankNativeLoaderTextHeader}>
          Hang in tight
        </span>
        <span className={styles.aubankNativeLoaderTextDesc}>
          Fetching your Fund details. This may take a few seconds. Stay on this
          screen
        </span>
      </div>
    </div>
  ) : (
    <div
      className={`${isPartialLoader ? styles.partialRoot : ''} ${
        styles.loaderRoot
      }`}
    >
      <span>Please Wait...</span>
    </div>
  );
};

export default NativeLoader;
